import { render } from "./HFruledit.vue?vue&type=template&id=f56fbf88&scoped=true"
import script from "./HFruledit.vue?vue&type=script&lang=js"
export * from "./HFruledit.vue?vue&type=script&lang=js"

import "./HFruledit.vue?vue&type=style&index=0&id=f56fbf88&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56fbf88"]])

export default __exports__